import { useMediaQuery, Dialog, IconButton, DialogContent, useTheme } from '@mui/material';
import { ImageFromServer } from './images/ImageFromServer';
import CloseIcon from '@mui/icons-material/Close';

export const ImageDialog = (props: { open: boolean; imageId: string; onClose: () => void }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog fullScreen={fullScreen} open={props.open} onClose={() => props.onClose()} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <IconButton
        aria-label="close"
        onClick={() => props.onClose()}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <ImageFromServer
          sx={{
            mt: 4,
            maxWidth: '100%',
            maxHeight: '80vh', // keeps it within viewport
            objectFit: 'contain', // preserves aspect ratio
            borderRadius: 4,
          }}
          id={props.imageId}
          alt={props.imageId}
          thumbnail={false}
        />
      </DialogContent>
    </Dialog>
  );
};
